<script setup lang="ts">
interface Props {}

defineProps<Props>();
</script>

<template>
    <span class="relative py-1 pl-2 pr-1 text-xs font-bold inline-block uppercase tracking-[.4375rem] bg-secondary bg-opacity-[0.16] text-primary">
        <slot></slot>
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute left-full top-0 h-full -translate-y-[.0313rem] w-auto" viewBox="0 0 13 25" fill="none">
            <path d="M13 0.5H0V24.5L13 0.5Z" fill="#52779E" fill-opacity="0.16" />
        </svg>
    </span>
</template>

<style lang="scss" scoped>
.label-white {
    @apply bg-white text-primary;

    svg path {
        @apply fill-white;

        fill-opacity: 1;
    }
}
</style>